import { Components } from '@mui/material'

export const MuiBackdropComponent = (): Components['MuiBackdrop'] => ({
  styleOverrides: {
    root: {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
    },
  },
})
